export default "__VITE_ASSET__c82786a0__"